export function dateToJson(d: Date): string{
    if(!d){
        return null;
    }
    return d.toISOString().split('T')[0];
}


// WEBPACK FOOTER //
// ./src/models/utils.ts